import TTUStep5 from 'assets/ttu/ttu-step-5.avif';
import TTUStep6 from 'assets/ttu/ttu-step-6.avif';
import TTUStep7 from 'assets/ttu/ttu-step-7.avif';
import TTUStep8 from 'assets/ttu/ttu-step-8.avif';
import TTUStep9 from 'assets/ttu/ttu-step-9.avif';
import TTUStep10 from 'assets/ttu/ttu-step-10.avif';
import TTUStep11 from 'assets/ttu/ttu-step-11.avif';
import TTUStep12 from 'assets/ttu/ttu-step-12.avif';
import TTUStep13 from 'assets/ttu/ttu-step-13.avif';

import { YoureNotAloneScreen } from '../steps/YoureNotAloneScreen';
import {
  Question2Decoration,
  Question3Decoration,
  Question4Decoration,
  Question5Decoration,
  Question6Decoration,
  Question7Decoration,
  Question8Decoration,
  Question9Decoration,
  Question10Decoration,
} from '../components/QuestionDecoration';

export const leadQuestions = [
  {
    content: 'What brings you to Nue life today?',
    subtitle: '(please choose all that apply)',
    sideImage: TTUStep5,
    decoration: Question2Decoration,
    stepNumber: 2,
    id: 'howAreYouFeeling',
    multi: true,
    type: 'question',
    salesforceId: 'How_are_you_feeling__c',
    gaTag: 'lead_question6_How_are_you_feeling',
    options: [
      {
        name: 'I feel depressed',
        value: 'Symptoms of depression',
      },
      {
        name: 'I feel anxious',
        value: 'Anxiety',
      },
      {
        name: 'I have PTSD',
        value: 'PTSD',
      },
      {
        name: "I'm have bipolar disorder",
        value: 'Bipolar disorder',
      },
      {
        name: "I'm curious about ketamine",
        value: "I'm curious about ketamine",
      },
      {
        name: 'Other',
        value: 'Other',
      },
    ],
  },
  {
    content: YoureNotAloneScreen,
    type: 'custom',
    gaTag: 'lead_question7_not_alone',
  },
  {
    content:
      'How familiar are you with the benefits of ketamine therapy for anxiety, depression and PTSD?',
    sideImage: TTUStep6,
    decoration: Question3Decoration,
    stepNumber: 3,
    id: 'howFamiliarAreYouWithTheBenefitsOfKetamineTherapyForAnxietyDepressionAndPtsd',
    type: 'question',
    salesforceId: 'How_familiar_are_you_with_ket__c',
    gaTag: 'lead_question9_How_familiar_are_you_with_ket',
    options: [
      {
        name: 'Very familiar',
        value: 'Very familiar',
      },
      {
        name: 'Somewhat familiar',
        value: 'Somewhat familiar',
      },
      {
        name: 'Not at all',
        value: 'Not at all',
      },
    ],
  },
  {
    content: 'Have you benefited from ketamine treatments in the past?',
    sideImage: TTUStep7,
    decoration: Question4Decoration,
    stepNumber: 4,
    id: 'haveYouBenefitedFromKetamineTreatmentsInThePast',
    type: 'question',
    salesforceId: 'Benefited_from_ketamine_Qual_Q_9__c',
    gaTag: 'lead_question10_Benefited_from_ketamine',
    options: [
      {
        name: 'Yes',
        value: 'Yes',
      },
      {
        name: 'No',
        value: 'No',
      },
    ],
  },
  {
    content: 'What is your goal with our program?',
    sideImage: TTUStep8,
    decoration: Question5Decoration,
    stepNumber: 5,
    subtitle: '(please select all that apply)',
    id: 'whatIsYourGoalWithOurProgram',
    type: 'question',
    salesforceId: 'What_is_your_goal_Qual_Q_1__c',
    gaTag: 'lead_question11_What_is_your_goal',
    multi: true,
    options: [
      {
        name: 'Relief from anxiety/depression/PTSD',
        value: 'Relief from anxiety/depression/PTSD',
      },
      {
        name: 'Get mental clarity',
        value: 'Get mental clarity',
      },
      {
        name: 'Get off my medications',
        value: 'Get off my medications',
      },
      {
        name: 'Mental reset',
        value: 'Mental reset',
      },
      {
        name: 'Improved motivation',
        value: 'Improved motivation',
      },
      {
        name: 'Stress relief',
        value: 'Stress relief',
      },
      {
        name: 'Other',
        value: 'Other',
      },
    ],
  },
  {
    content: 'What key areas are you hoping to improve with yourself?',
    sideImage: TTUStep9,
    decoration: Question6Decoration,
    stepNumber: 6,
    subtitle: '(please select all that apply)',
    id: 'whatKeyAreasAreYouHopingToImprove',
    multi: true,
    salesforceId: 'What_key_areas_improvement_Qual_Q__c',
    gaTag: 'lead_question12_What_key_areas_improvement',
    type: 'question',
    options: [
      {
        name: 'Professional life',
        value: 'Professional life',
      },
      {
        name: 'Social interactions',
        value: 'Social interactions',
      },
      {
        name: 'Sleeping',
        value: 'Sleeping',
      },
      {
        name: 'Trouble relaxing',
        value: 'Trouble relaxing',
      },
      {
        name: 'Personal Goals',
        value: 'Personal Goals',
      },
      {
        name: 'Other',
        value: 'Other',
      },
    ],
  },
  {
    content: 'Are you currently working with a mental health therapist?',
    sideImage: TTUStep10,
    decoration: Question7Decoration,
    stepNumber: 7,
    id: 'areYouCurrentlyWorkingWithATherapist',
    salesforceId: 'Working_with_a_counselor_Qual_Q_2__c',
    type: 'question',
    gaTag: 'lead_question13_Working_with_a_counselor',
    options: [
      {
        name: 'Yes',
        value: 'Yes',
      },
      {
        name: 'No',
        value: 'No',
      },
    ],
  },
  {
    content:
      'After your treatment, research has shown that your brain is more receptive to changing patterns.',
    sideImage: TTUStep11,
    decoration: Question8Decoration,
    stepNumber: 8,
    subtitle:
      'Did you know Nue Life includes personal health coaching and integration sessions during your treatment?',
    type: 'question',
    id: 'didYouKnowSessions',
    salesforceId: 'Nue_Life_includes_HC_and_IS__c',
    gaTag: 'lead_question14_Nue_Life_includes_HC_and_IS__c',
    options: [
      {
        name: 'Yes',
        value: 'Yes',
      },
      {
        name: 'No',
        value: 'No',
      },
    ],
  },
  {
    content: 'Do any of the following apply to you?',
    sideImage: TTUStep12,
    decoration: Question9Decoration,
    stepNumber: 9,
    footer:
      'Nue Life may not be suitable for everyone or every situation. \n If you are in a life-threatening situation, call the National Suicide Prevention Line at +1-800-273-8255, call *988, or go to the nearest emergency room.\n Nue Life does not provide live monitoring of responses.',
    id: 'notFit1',
    disqualifying: true,
    multiSalesforce: true,
    multi: true,
    gaTag: 'lead_question17_Red_Flag',
    options: [
      {
        value: 'I struggle with symptoms of depression or anxiety',
        salesforceId: 'Struggle_with_symptoms_of_dep_or_anxiety__c',
      },
      {
        value:
          'I have experienced a traumatic event that has caused nightmares, intrusive thoughts, or avoidance behaviors that continue to cause distress',
        salesforceId: 'Experienced_traumatic_event_PTSD_screen__c',
      },
      {
        value: 'Breastfeeding or pregnant',
        salesforceId: 'Possibility_of_Pregnancy__c',
      },
      {
        value:
          'Diagnosed with schizophrenia, schizoaffective disorder or schizoid personality disorder',
        salesforceId: 'Red_Flag_Q7__c',
      },
      {
        value: 'Current or past ABUSE of ketamine',
        salesforceId: 'Red_Flag_Q9__c',
      },
      {
        value:
          'Within the past three months, had thoughts about hurting yourself or others',
        salesforceId: 'Red_Flag_Q1__c',
      },
      {
        value:
          "I don't have a trusted adult who can be present with me during each Nue Life ketamine experience",
        salesforceId: 'Adult_who_can_be_present_for_experiences__c',
      },
      {
        value: 'Currently receiving Dialysis treatments',
        salesforceId: 'Currently_receiving_Dialysis_treatment__c',
      },
      {
        value: 'Had an organ transplant within the last year',
        salesforceId: 'Had_organ_transplant_in_the_last_year__c',
      },
      {
        value: 'Have ever experienced psychosis or psychotic episodes?',
        salesforceId: 'Experienced_psychosis_or_hallucinations__c',
      },
      {
        value: 'None of the above',
      },
    ],
    positiveValues: [
      'I struggle with symptoms of depression or anxiety',
      'I have experienced a traumatic event that has caused nightmares, intrusive thoughts, or avoidance behaviors that continue to cause distress',
    ],
  },
  {
    content: 'Are any of the below relevant to you?',
    sideImage: TTUStep13,
    decoration: Question10Decoration,
    stepNumber: 10,
    footer:
      'Nue Life may not be suitable for everyone or every situation. \n If you are in a life-threatening situation, call the National Suicide Prevention Line at +1-800-273-8255, call *988, or go to the nearest emergency room. \n Nue Life does not provide live monitoring of responses.',
    id: 'notFit2',
    multiSalesforce: true,
    multi: true,
    checkoutIfPositive: true,
    gaTag: 'lead_question18_Orange_Flag',
    options: [
      {
        value:
          'Diagnosed with dissociative disorders (i.e. dissociative identity disorder)',
        salesforceId: 'Red_Flag_Q6__c',
      },
      {
        value: 'Have ever experienced hallucinations',
        salesforceId: 'Ever_experienced_hallucinations__c',
      },
      {
        value:
          'Have ever done anything, started to do anything, or prepared to anything to end your life',
        salesforceId: 'Red_Flag_Q2__c',
      },
      {
        value:
          'Aside from the required sitter, I would require assistance from a caregiver to participate in the Nue Life program',
        salesforceId: 'Red_Flag_Q13__c',
      },
      {
        value: "Don't feel safe at home",
        salesforceId: 'Red_Flag_Q14__c',
        invertSelection: true,
      },
      {
        value: 'Have taken any form of Ketamine in the past 3 months',
        salesforceId: 'Red_Flag_Q8__c',
      },
      {
        value: 'Have history of a drug or alcohol use disorder',
        salesforceId: 'Red_Flag_Q5__c',
      },
      {
        value: 'Hospitalized for a psychiatric condition',
        salesforceId: 'Red_Flag_Q3__c',
      },
      {
        value: 'Diagnosed with a psychotic disorder',
        salesforceId: 'Diagnosed_with_a_psychotic_disorder__c',
      },
      {
        value:
          'Currently (or have you been in the last 3 months) using illicit drugs or substances',
        salesforceId: 'Current_Use_of_Illicit_Substances__c',
      },
      {
        value: 'I am taking Methadone, Suboxone, Buprenorphine, or Narcan',
        salesforceId: 'Suboxone_Buprenorphine_or_Narcan__c',
      },
      {
        value: 'Been to a substance rehabilitation center within the past year',
        salesforceId: 'Red_Flag_Q16__c',
      },
      {
        value:
          'Have or have been hospitalized for any of: Heart Problems (Arrhythmia/Tachycardia); Liver or Kidney Problems; Uncontrolled High Blood Pressure; History of Brain Injury; Epilepsy/Seizures; Cancer; Breathing Problems',
        salesforceId: 'Red_Flag_Q18__c',
      },
      {
        value: 'Have ever experienced hallucinations',
        salesforceId: 'Ever_experienced_hallucinations__c',
      },
      {
        value: 'None of the above',
      },
    ],
    positiveValue: 'None of the above',
  },
];